<template>
  <div class="c-table" ref="documenttable">
    <!-- <Spin size="large" fix v-if="loading"></Spin> -->
    <el-table class="common-el-table-styles" :data="data" :height="height" border stripe v-loading="loading">
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-edit', scope.row)">修改</el-button>
            <Poptip confirm transfer title="您确认删除该配置吗？" @on-ok="$emit('on-del', scope.row)">
              <el-button type="text" size="small"> &ensp;删除 </el-button>
            </Poptip>
          </div>
          <span v-else-if="['upTime', 'createTime', 'operationTime'].includes(col.key)">
            {{ scope.row[col.key] | datetimeToSec }}
          </span>
          <span v-else-if="col.key === 'mediaName'">{{ getMediaName(scope.row) }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'toutiaoGameConfigTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  methods: {
    getMediaName(row) {
      if (row.mediaId === 10) return '巨量引擎'
      if (row.mediaId === 16) return '腾讯'
      if (row.mediaId === 32) return '磁力引擎'
      return ''
    }
  }
}
</script>
